import React, { useContext, useEffect, useState } from "react";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import NavBar from "../components/NavBar";
import ServiceDetailsArea from "../components/ServiceDetailsArea";
import {
  FaAngleDoubleRight,
  FaArrowRight,
  FaCalendar,
  FaCalendarAlt,
  FaCalendarCheck,
  FaCalendarDay,
  FaCalendarTimes,
  FaCheckCircle,
  FaFile,
  FaFileAlt,
  FaFolder,
  FaQuestion,
  FaUser,
} from "react-icons/fa";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  useMatch,
  useResolvedPath,
  useLocation,
  Navigate,
  BrowserRouter,
} from "react-router-dom";
import ProfilePatient from "./ProfilePatient";
import Parametres from "./Parametres";
import MesDocuments from "./MesDocuments";
import MesDeclarations from "./MesDeclarations";
import FAQ from "./FAQ";
import MesRendezVous from "./MesRendezVous";
import DetailsDeclarations from "./DetailsDeclarations";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import NewDeclaration from "./Declarations/NewDeclaration";
import { ApiUrl } from "../config";
import { FileLink, FileLinkImg } from "../config";

const EspaceHnaMeak = () => {
  const location = useLocation();
  const [selected, setSelected] = useState("mon-profile"); // Set default selection to 'mon-profile'
  const resolvedPath = useResolvedPath();

  useEffect(() => {
    const currentPath = location.pathname.split("/").pop();
    handleSelection(currentPath || "mon-profile");
  }, [location]);

  const handleSelection = (path) => {
    setSelected(path);
  };

  const [citoyenInfo, setCitoyenInfo] = useState([]);
  const token = Cookies.get("access_token");

  const GetCitoyenById = async (page) => {
    if (token) {
      const decodedToken = jwtDecode(token);
      const citoyen_id = decodedToken.citoyen_id;
      try {
        const response = await fetch(
          `${ApiUrl}citoyen-by-id?citoyen_id=${citoyen_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        setCitoyenInfo(data.citoyen);
        //   console.log(data)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    GetCitoyenById();
  }, [token]);

  return (
    <div
      className="row ms-1"
      style={{ paddingTop: "10px", paddingBottom: "40px", height: "100%" }}
    >
      <div className=" col-xl-2 col-lg-3 col-md-3 col-12 border-end">
        <div class="text-center border-bottom">
          <div class="thumb">
            <img
              style={{
                maxWidth: "86px",
                background: "#e9ecef",
                borderRadius: "50%",
              }}
               src={`${FileLinkImg}hna-meak/women-removebg-preview.png`}
              alt="img"
            />
          </div>
          <div class="details mt-2">
            <h5>
              {" "}
              {citoyenInfo?.nom || "-"} {citoyenInfo?.prenom || "-"}
            </h5>
          </div>
        </div>

        <div className="td-sidebar service-sidebar">
          <div className="widget widget_download">
            <ul>
              <li className={selected === "mon-profile" ? "selected" : ""}>
                <Link
                  to="mon-profile"
                  onClick={() => handleSelection("mon-profile")}
                >
                  Mon Profile <FaUser />
                </Link>
              </li>
              <li className={selected === "mes-rendez-vous" ? "selected" : ""}>
                <Link
                  to="mes-rendez-vous"
                  onClick={() => handleSelection("mes-rendez-vous")}
                >
                  Mes Rendez-vous <FaCalendarAlt />
                </Link>
              </li>
              <li className={selected === "mes-declarations" ? "selected" : ""}>
                <Link
                  to="mes-declarations"
                  onClick={() => handleSelection("mes-declarations")}
                >
                  Mes Dossiers
                  <FaFolder />
                </Link>
              </li>
              {/* <li className={selected === "mes-documents" ? "selected" : ""}>
                <Link
                  to="mes-documents"
                  onClick={() => handleSelection("mes-documents")}
                >
                  Mes Documents <FaFileAlt />
                </Link>
              </li> */}
              <li className={selected === "parametres" ? "selected" : ""}>
                <Link
                  to="parametres"
                  onClick={() => handleSelection("parametres")}
                >
                  Paramètres <FaFileAlt />
                </Link>
              </li>
              <li className={selected === "faq" ? "selected" : ""}>
                <Link to="faq" onClick={() => handleSelection("faq")}>
                  FAQ <FaQuestion />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="col-xl-10 col-lg-9 col-md-9 my-patient-content mt-2">
        <Routes>
          <Route path="/" element={<Navigate to="mon-profile" />} />
          <Route path="mes-rendez-vous" element={<MesRendezVous />} />
          <Route path="mon-profile" element={<ProfilePatient />} />
          <Route path="mes-declarations" element={<MesDeclarations />} />
          <Route path="detail-dossier" element={<DetailsDeclarations />} />
          <Route
            path="detail-dossier/:dec_uid"
            element={<DetailsDeclarations />}
          />
          <Route path="nouvelle-declaration" element={<NewDeclaration />} />
          <Route path="mes-documents" element={<MesDocuments />} />
          <Route path="parametres" element={<Parametres />} />
          <Route path="faq" element={<FAQ />} />
        </Routes>
      </div>
    </div>
  );
};

export default EspaceHnaMeak;
